import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import activeStar from "resources/img/other/Star 1.svg";
import passiveStar from "resources/img/other/Star 2.svg";
import eyeIcon from "resources/img/puffu/main/eye.svg";
import qrIcon from "resources/img/puffu/main/qrIcon.svg";
import puffuIcon from "resources/img/puffu/puffuIcon.svg";
import rightIcon from "resources/img/puffu/right.png";
import { FavoriteReducer } from "shared/redux/reducers/shopping/FavoriteReducer";
import iconImg from "resources/img/puffu/icon.png";
import doorImg from "resources/img/puffu/door.png";
import { formatLocalDate } from "shared/utils/Utils";
import SimpleStoreDetailModal from "modals/store/SimpleStoreDetailModal";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import biometricService from '../../../shared/BiometricService';
import PinVerificationManager from '../../../utils/PinVerificationManager';
import { toast } from 'react-toastify';
import { devLog } from "utils/logger";


function Main2() {
    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const { id } = useParams();
    const navigate = useNavigate();
    const [nearbyStores, setNearbyStores] = useState([]);
    const [storesLoading, setStoresLoading] = useState(true);
    const [recentOrders, setRecentOrders] = useState([]);
    const [ordersLoading, setOrdersLoading] = useState(true);
    const defaultProductImage = "/assets/images/default-product.png";
    const [showModal, setShowModal] = useState(false);
    const [selectedStore, setSelectedStore] = useState(null);
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const [authenticationState, setAuthenticationState] = useState('idle');

    // 🔥 심사용 테스트 계정 목록
    const reviewerAccounts = ['01088888888', '01077777777', '01066666666'];

    // 매장 데이터 가져오기
    useEffect(() => {
        // 매장 목록 바로 가져오기
        setStoresLoading(true);
        requester.findAllByConfirmYnIsTrue((result) => {
            devLog("매장 API 결과:", result);
            if (result.code === 0) {
                if (!result.data || result.data.length === 0) {
                    console.warn("매장 목록이 비어있습니다.");
                    // 더미 데이터 추가 (실제 API에서 데이터가 없을 경우)
                    const dummyStores = [
                        {
                            id: 'dummy1',
                            storeName: '둔산점(준비중)',
                            storeImg: '/assets/images/store-placeholder.jpg',
                            place_name: '둔산점(준비중)',
                            address: '대전 서구 둔산동',
                            distance: 1.2,
                            isDummy: true
                        },
                        {
                            id: 'dummy2',
                            storeName: '봉명점(준비중)',
                            storeImg: '/assets/images/store-placeholder.jpg',
                            place_name: '봉명점(준비중)',
                            address: '대전 유성구 봉명동',
                            distance: 2.5,
                            isDummy: true
                        },
                        {
                            id: 'dummy3',
                            storeName: '관평점(준비중)',
                            storeImg: '/assets/images/store-placeholder.jpg',
                            place_name: '관평점(준비중)',
                            address: '대전 유성구 관평동',
                            distance: 3.1,
                            isDummy: true
                        },
                        {
                            id: 'dummy4',
                            storeName: '신촌점(준비중)',
                            storeImg: '/assets/images/store-placeholder.jpg',
                            place_name: '신촌점(준비중)',
                            address: '서울시 서대문구 신촌로',
                            distance: 3.8,
                            isDummy: true
                        }
                    ];
                    setNearbyStores(dummyStores);
                } else {
                    try {
                        // 서버에서 받은 매장 목록을 그대로 사용 (위치 기반 거리 계산 없음)
                        let stores = result.data.map(store => ({
                            ...store,
                            place_name: store.storeName,
                            address_name: store.address,
                            x: store.longitudeByY || '0',
                            y: store.latitudeByX || '0',
                            // 임의의 거리값 (UI 표시용)
                            distance: 1.5
                        }));

                        // 데이터가 적을 경우 더미데이터 추가 (항상 최소 3개 이상의 매장 보장)
                        if (stores.length < 3) {
                            const dummyStores = [
                                {
                                    id: 'dummy1',
                                    storeName: '둔산점',
                                    storeImg: '/assets/images/store-placeholder.jpg',
                                    place_name: '둔산점',
                                    address: '대전 서구 둔산동',
                                    distance: 1.2,
                                    isDummy: true
                                },
                                {
                                    id: 'dummy2',
                                    storeName: '봉명점',
                                    storeImg: '/assets/images/store-placeholder.jpg',
                                    place_name: '봉명점',
                                    address: '대전 유성구 봉명동',
                                    distance: 2.5,
                                    isDummy: true
                                },
                                {
                                    id: 'dummy3',
                                    storeName: '관평점',
                                    storeImg: '/assets/images/store-placeholder.jpg',
                                    place_name: '관평점',
                                    address: '대전 유성구 관평동',
                                    distance: 3.1,
                                    isDummy: true
                                }
                            ];

                            // 실제 데이터와 더미데이터 합치기 (3개까지 채우기)
                            stores = [...stores, ...dummyStores.slice(0, 3 - stores.length)];
                        }

                        devLog("매장 데이터 처리 완료:", stores.length);
                        setNearbyStores(stores);
                    } catch (err) {
                        console.error("매장 데이터 처리 중 오류:", err);
                    }
                }
            } else {
                console.error("매장 목록 API 오류:", result);
                // API 오류 시 더미 데이터 사용
                const dummyStores = [
                    {
                        id: 'dummy1',
                        storeName: '둔산점',
                        storeImg: '/assets/images/store-placeholder.jpg',
                        place_name: '둔산점',
                        address: '대전 서구 둔산동',
                        distance: 1.2,
                        isDummy: true
                    },
                    {
                        id: 'dummy2',
                        storeName: '봉명점',
                        storeImg: '/assets/images/store-placeholder.jpg',
                        place_name: '봉명점',
                        address: '대전 유성구 봉명동',
                        distance: 2.5,
                        isDummy: true
                    },
                    {
                        id: 'dummy3',
                        storeName: '관평점',
                        storeImg: '/assets/images/store-placeholder.jpg',
                        place_name: '관평점',
                        address: '대전 유성구 관평동',
                        distance: 3.1,
                        isDummy: true
                    }
                ];
                setNearbyStores(dummyStores);
            }
            setStoresLoading(false);
        });
    }, []);

    // Fetch recent orders
    useEffect(() => {
        const fetchRecentOrders = async () => {
            setOrdersLoading(true);
            requester.findLastThreeOrder({}, (result) => {
                if (result.code === 0 && result.data) {
                    setRecentOrders(result.data);
                }
                setOrdersLoading(false);
            });
        };

        fetchRecentOrders();
    }, []);

    /**
     * 🔥 생체인증/PIN 인증 통합 처리 함수
     * @param {Function} onSuccess - 인증 성공 시 실행할 함수
     * @param {string} actionType - 액션 타입 ('door' 또는 'qr')
     */
    const handleAuthenticatedAction = async (onSuccess, actionType = 'qr') => {
        if (isAuthenticating) {
            devLog("[Main2] 이미 인증 중이므로 무시");
            return;
        }

        try {
            setIsAuthenticating(true);
            setAuthenticationState('verifying'); // 🔥 바로 검증 상태로 변경
            
            devLog(`[Main2] ${actionType} 액션을 위한 인증 시작`);
            
            // 🔥 PinVerificationManager에게 모든 인증 로직 위임 (생체인증 + PIN)
            // 사용자 데이터 준비
            const userData = {
                phoneNumber: biometricService.getPhoneNumber() || userName || 'unknown'
            };
            
            // 🔥 PIN 검증 시도 횟수 초기화 (새로운 인증 시작)
            PinVerificationManager.resetAttempts();
            
            // 🔥 PinVerificationManager가 생체인증 → PIN 순서로 처리
            await PinVerificationManager.executeVerification(userData, {
                onSuccess: () => {
                    devLog("[Main2] 📱 인증 성공");
                    setAuthenticationState('success');
                    onSuccess();
                },
                onFailure: (message, isMaxAttempts) => {
                    devLog("[Main2] 📱 인증 실패:", message);
                    if (isMaxAttempts) {
                        toast.error("인증 횟수를 초과했습니다. 잠시 후 다시 시도해주세요.");
                    } else {
                        toast.error(message || "인증에 실패했습니다.");
                    }
                },
                onError: (error) => {
                    console.error("[Main2] 📱 인증 오류:", error);
                    // toast.error("인증 중 오류가 발생했습니다.");
                },
                onStateChange: (state, message) => {
                    devLog(`[Main2] 인증 상태 변경: ${state} - ${message}`);
                    
                    // 🔥 PinVerificationManager의 상태를 Main2 UI에 반영
                    if (state === 'verifying' && message && message.includes('생체인증')) {
                        setAuthenticationState('biometric');
                    } else if (state === 'verifying' && message && message.includes('PIN')) {
                        setAuthenticationState('pin');
                    } else if (state === 'server_verifying') {
                        setAuthenticationState('pin'); // 서버 검증 중에도 PIN 상태 유지
                    }
                }
            });
            
        } catch (error) {
            console.error(`[Main2] ${actionType} 인증 처리 중 오류:`, error);
            toast.error("인증 중 오류가 발생했습니다.");
        } finally {
            setIsAuthenticating(false);
            setAuthenticationState('idle');
        }
    };

    /**
     * 🔥 출입문 열기 버튼 클릭 핸들러 (인증 포함)
     */
    const onDoorOpenClick = () => {
        // --- 심사 기간 임시 코드 ---
        // 심사 완료 후, 이 함수 내의 모든 코드를 아래 '원본 코드'로 교체하세요.

        const doorOpenAction = () => {
            devLog("[Main2] 출입문 열기 실행");
            if (window.BRIDGE && window.BRIDGE.scan) {
                window.BRIDGE.scan();
            } else if (window.webkit?.messageHandlers?.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('scan');
            } else {
                toast.success("출입문이 열렸습니다.");
            }
        };

        if (reviewerAccounts.includes(userName)) {
            // 심사 계정: 기존 인증 로직 실행
            devLog("[Main2] 심사 계정으로 출입문 열기 인증 실행");
            handleAuthenticatedAction(doorOpenAction, 'door');
        } else {
            // 일반 사용자: 인증 건너뛰기
            devLog("[Main2] (임시) 인증 건너뛰고 출입문 열기 실행");
            doorOpenAction();
        }
        /*
        // --- 원본 코드 (심사 완료 후 복원) ---
        handleAuthenticatedAction(() => {
            // 인증 성공 시 실행할 원래 로직
            devLog("[Main2] 출입문 열기 실행");
            if (window.BRIDGE && window.BRIDGE.scan) {
                window.BRIDGE.scan();
            } else if (window.webkit?.messageHandlers?.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('scan');
            } else {
                // 네이티브 브릿지가 없는 경우 폴백
                toast.success("출입문이 열렸습니다.");
            }
        }, 'door');
        */
    };

    /**
     * 🔥 QR 결제 버튼 클릭 핸들러 (인증 포함)
     */
    const onScanClick = () => {
        // --- 심사 기간 임시 코드 ---
        // 심사 완료 후, 이 함수 내의 모든 코드를 아래 '원본 코드'로 교체하세요.

        const scanAction = () => {
            devLog("[Main2] QR 스캔 실행");
            if (window.BRIDGE && window.BRIDGE.scan) {
                window.BRIDGE.scan();
            } else if (window.webkit?.messageHandlers?.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('scan');
            } else {
                toast.info("QR 스캔 기능을 사용할 수 없습니다.");
            }
        };

        if (reviewerAccounts.includes(userName)) {
            // 심사 계정: 기존 인증 로직 실행
            devLog("[Main2] 심사 계정으로 QR 스캔 인증 실행");
            handleAuthenticatedAction(scanAction, 'qr');
        } else {
            // 일반 사용자: 인증 건너뛰기
            devLog("[Main2] (임시) 인증 건너뛰고 QR 스캔 실행");
            scanAction();
        }
        /*
        // --- 원본 코드 (심사 완료 후 복원) ---
        handleAuthenticatedAction(() => {
            // 인증 성공 시 실행할 원래 로직
            devLog("[Main2] QR 스캔 실행");
            if (window.BRIDGE && window.BRIDGE.scan) {
                window.BRIDGE.scan();
            } else if (window.webkit?.messageHandlers?.BRIDGE) {
                window.webkit.messageHandlers.BRIDGE.postMessage('scan');
            } else {
                // 네이티브 브릿지가 없는 경우 폴백
                toast.info("QR 스캔 기능을 사용할 수 없습니다.");
            }
        }, 'qr');
        */
    };

    const handleClick = (store) => {
        setSelectedStore(store);
        setShowModal(true);
    };
    
    // 매장 카드 컴포넌트
    const StoreCard = ({ store }) => {
        // 더미 매장인 경우 클릭 핸들러를 null로 설정
        const handleStoreClick = store.isDummy ? null : () => handleClick(store);

        // distance 값을 콘솔에 출력
        devLog(`Store ${store.place_name} distance:`, store.distance);

        return (
            <div
                onClick={handleStoreClick}
                style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "8px",
                    cursor: store.isDummy ? "default" : "pointer",
                    height: "180px",
                    overflow: "hidden",
                    boxShadow: "2px 2px 8px rgba(0,0,0,0.05)",
                    width: "100%"
                }}
            >
                <div style={{
                    width: "100%",
                    height: "120px",
                    position: "relative"
                }}>
                    {store.isDummy ? (
                        // 준비중인 매장은 간단한 회색 배경 사용
                        <div style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#f8f8f8",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <img src={iconImg} width={"50%"} />
                            {/* 텍스트 제거하고 필요시 아이콘만 표시 */}
                        </div>
                    ) : (
                        <img src={store.storeImg || '/assets/images/store-placeholder.jpg'}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            alt={store.place_name} />
                    )}
                </div>
                <div style={{ padding: "6px 12px" }}>
                    <div style={{ marginBottom: "4px" }}>
                        <P ellipsis color={"#333"} weight={600} size={16}>
                            {store.place_name}
                            {store.isDummy && (
                                <span style={{
                                    backgroundColor: "#ececec",
                                    borderRadius: "4px",
                                    padding: "2px 4px",
                                    fontSize: "10px",
                                    color: "#666",
                                    marginLeft: "6px",
                                    fontWeight: "500",
                                    verticalAlign: "middle"
                                }}>
                                    SOON
                                </span>
                            )}
                        </P>
                    </div>
                    <P color={"#666"} size={14}>
                        {store.isDummy ? "오픈 준비중" : "영업중"}
                    </P>
                </div>
            </div>
        );
    };

    const ViewMoreCard = () => {
        return (
            <div
                onClick={handleViewAll}
                style={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "12px",
                    cursor: "pointer",
                    height: "180px",
                    overflow: "hidden",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <div style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "25px",
                    backgroundColor: "#FF5722",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "12px"
                }}>
                    <img src={rightIcon} style={{ width: "14px", filter: "brightness(0) invert(1)" }} alt="더보기" />
                </div>
                <P color={"#333"} weight={600} size={16}>주변매장</P>
                <P color={"#666"} size={14}>더 보기</P>
            </div>
        );
    };

    const QRIcon = () => (
        <svg width="52" height="52" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <rect x="18" y="4" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <rect x="4" y="18" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <rect x="18" y="18" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <rect x="7" y="7" width="4" height="4" fill="currentColor" />
            <rect x="21" y="7" width="4" height="4" fill="currentColor" />
            <rect x="7" y="21" width="4" height="4" fill="currentColor" />
            <rect x="21" y="21" width="4" height="4" fill="currentColor" />
        </svg>
    );

    const ShoppingBagIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ProductIcon = () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#EEEEEE" />
            <path d="M17 9V7C17 5.89543 16.1046 5 15 5H9C7.89543 5 7 5.89543 7 7V9M17 9H7M17 9V17C17 18.1046 16.1046 19 15 19H9C7.89543 19 7 18.1046 7 17V9" stroke="#999999" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M12 12V15" stroke="#999999" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10 14L14 14" stroke="#999999" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );

    if (storesLoading) return <p>매장 정보를 불러오는 중...</p>;

    const findStoreClick = () => {
        navigate(`/ws/${id}/mobile/shopping`);
    }

    const navigateToOrderHistory = () => {
        navigate(`/ws/${id}/mobile/orderHistory`);
    };

    const handleViewAll = () => {
        navigate(`/ws/${id}/mobile/map`);
    };

    const RecentOrderItem = ({ order, orderProduct }) => {
        return (
            <FlexChild>
                <div
                    key={order.id}
                    onClick={() => navigate(`/ws/${id}/mobile/receipt/detail/${order.id}`, {
                        state: { data: order }
                    })}
                    style={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "12px",
                        padding: "0 16px",
                        cursor: "pointer",
                    }}
                >
                    <HorizontalFlex gap={16} alignItems="center">
                        <FlexChild width={"60px"} flexShrink={0}>
                            <div style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "8px",
                                overflow: "hidden",
                                backgroundColor: "#f5f5f5",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                {orderProduct.productImg && orderProduct.productImg !== "" ? (
                                    <img
                                        src={orderProduct.productImg}
                                        alt={orderProduct.productName}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />
                                ) : (
                                    <Center>
                                        <ProductIcon />
                                    </Center>
                                )}
                            </div>
                        </FlexChild>
                        <FlexChild flex={1}>
                            <VerticalFlex gap={2} flexStart>
                                <P color={"#333"} size={16} weight={600}>
                                    {orderProduct.productName}
                                </P>
                                <P color={"#666"} size={14}>
                                    {formatLocalDate(order.createDateTime)}
                                </P>
                                <P color={"#666"} size={14}>
                                    {order.amount.toLocaleString()}원
                                </P>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild width={"auto"} flexShrink={0}>
                            <HorizontalFlex gap={12} alignItems="center">
                                <div style={{
                                    padding: "5px 10px",
                                    backgroundColor: "var(--main-color)",
                                    borderRadius: "4px",
                                }}>
                                    <P color={"white"} size={10} weight={500}>
                                        수령 완료
                                    </P>
                                </div>
                                <img
                                    src={rightIcon}
                                    style={{
                                        width: "7px",
                                        opacity: 0.7
                                    }}
                                />
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
            </FlexChild>
        );
    };

    return (
        <Container backgroundColor={"var(--bg-color)"} >
            <VerticalFlex gap={20} >
                {/* 상단 헤더 영역 */}
                <FlexChild height={"50px"} width={"90%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <Center width={'100%'} textAlign={"left"}>
                                {/* <P color={"#333"} size={24} weight={700}>{userName} 님</P> */}
                            </Center>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>

                {/* QR 결제 버튼 */}
                <FlexChild height={"max-content"} width={"95%"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <div
                                onClick={onDoorOpenClick}
                                style={{
                                    backgroundColor: isAuthenticating && authenticationState !== 'idle' ? "#cccccc" : "rgb(0, 168, 221)",
                                    borderRadius: "12px",
                                    width: "93%",
                                    margin: "0 auto",
                                    cursor: isAuthenticating ? "not-allowed" : "pointer",
                                    padding: "24px",
                                    position: "relative",
                                    overflow: "hidden",
                                    boxShadow: "0 8px 20px rgba(0, 120, 160, 0.25)",
                                    opacity: isAuthenticating && authenticationState !== 'idle' ? 0.7 : 1
                                }}
                            >
                                <div style={{ position: "relative", zIndex: 2 }}>
                                    <P textAlign={"right"} color={"white"} size={20} weight={700}>
                                        출입문
                                    </P>
                                    <P textAlign={"right"} color={"white"} size={20} weight={700}>
                                        열기
                                    </P>
                                </div>
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "white",
                                    opacity: 0.9,
                                    zIndex: 2
                                }}>
                                    <img src={doorImg} width={"50px"} style={{ filter: "invert(100%)"}} />
                                </div>
                                <div style={{
                                    position: "absolute",
                                    right: "-20px",
                                    top: "-20px",
                                    width: "120px",
                                    height: "120px",
                                    background: "rgba(255,255,255,0.1)",
                                    borderRadius: "60px",
                                    zIndex: 1
                                }} />
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div
                                onClick={onScanClick}
                                style={{
                                    backgroundColor: isAuthenticating && authenticationState !== 'idle' ? "#cccccc" : "#FF5722",
                                    borderRadius: "12px",
                                    width: "93%",
                                    margin: "0 auto",
                                    cursor: isAuthenticating ? "not-allowed" : "pointer",
                                    padding: "24px",
                                    position: "relative",
                                    overflow: "hidden",
                                    boxShadow: "0 8px 20px rgba(255, 87, 34, 0.25)",
                                    opacity: isAuthenticating && authenticationState !== 'idle' ? 0.7 : 1
                                }}
                            >
                                <div style={{ position: "relative", zIndex: 2 }}>
                                    <P textAlign={"right"} color={"white"} size={20} weight={700}>
                                         QR
                                    </P>
                                    <P textAlign={"right"} color={"white"} size={20} weight={700}>
                                        결제
                                    </P>
                                </div>
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "white",
                                    opacity: 0.9,
                                    zIndex: 2
                                }}>
                                    <QRIcon />
                                </div>
                                <div style={{
                                    position: "absolute",
                                    right: "-20px",
                                    top: "-20px",
                                    width: "120px",
                                    height: "120px",
                                    background: "rgba(255,255,255,0.1)",
                                    borderRadius: "60px",
                                    zIndex: 1
                                }} />
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>

                {/* 내 주변 매장 섹션 */}
                <FlexChild height={"182px"} justifyContent={"center"} backgroundColor={"white"}>
                    <VerticalFlex width={"90%"} margin="0 auto" gap={15}>
                        {storesLoading ? (
                            <Center height={"180px"} width="100%">
                                <P color={"#666"}>매장 정보를 불러오는 중...</P>
                            </Center>
                        ) : nearbyStores && nearbyStores.length > 0 ? (
                            <div style={{ width: "100%" }}>
                                <Swiper
                                    modules={[FreeMode]}
                                    spaceBetween={10}
                                    slidesPerView={2.5}
                                    freeMode={true}
                                    style={{ width: "100%" }}
                                >
                                    {/* 매장 카드들을 슬라이드로 표시 */}
                                    {nearbyStores.map((store, index) => (
                                        <SwiperSlide key={index}>
                                            <StoreCard store={store} />
                                        </SwiperSlide>
                                    ))}

                                    {/* 더보기 카드 */}
                                    <SwiperSlide>
                                        <ViewMoreCard />
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        ) : (
                            <Center height={"180px"} width="100%">
                                <P color={"#666"}>표시할 매장이 없습니다</P>
                            </Center>
                        )}
                    </VerticalFlex>
                </FlexChild>
                {/* 쇼핑몰 추천 섹션 */}
                <FlexChild height={"max-content"}>
                    <div
                        onClick={findStoreClick}
                        style={{
                            width: "90%",
                            margin: "0 auto",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "12px",
                            padding: "16px",
                            cursor: "pointer",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                        }}
                    >
                        <HorizontalFlex alignItems="center" gap={12}>
                            <FlexChild width={"max-content"}>
                                <div style={{
                                    width: "48px",
                                    height: "48px",
                                    backgroundColor: "#FF5722",
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "white",
                                    flexShrink: 0
                                }}>
                                    <ShoppingBagIcon />
                                </div>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex flex={1} flexStart>
                                    <P color={"#333"} weight={600} size={16}>전체 쇼핑몰</P>
                                    <P color={"#666"} size={14}>다양한 상품을 둘러보세요</P>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild style={{ textAlign: "right", width: "24px", flexShrink: 0 }} justifyContent={"flex-end"} width={"max-content"}>
                                <img src={rightIcon} style={{ width: "7px" }} />
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
                {/* <FlexChild height={"max-content"} width={"90%"}>
                    <P cursor color={"white"} backgroundColor={"var(--main-color)"} padding={"0 12px"} onClick={getFaceIdToken}>FaceIdTest</P>
                </FlexChild> */}

                {/* 최근 주문 내역 섹션 */}
                <FlexChild height={"max-content"} width={"90%"}>

                    <div style={{
                        backgroundColor: "#FFFFFF",
                        borderRadius: "12px",
                        boxShadow: "0px 3px 10px rgba(0,0,0,0.08)",
                        padding: "12px 0",
                        marginBottom: "10px"
                    }}>
                        <VerticalFlex gap={16}>
                            {ordersLoading ? (
                                <Center height={"100px"}>
                                    <P color={"#666"}>주문 내역을 불러오는 중...</P>
                                </Center>
                            ) : recentOrders.length > 0 ? (
                                <>
                                    {recentOrders.slice(0, 1).map((order) => {
                                        const orderProduct = order.orderProducts[0]; // 첫 번째 상품 정보 사용
                                        return (
                                            <RecentOrderItem key={order.id} order={order} orderProduct={orderProduct} />
                                        );
                                    })}

                                    {/* 더보기 버튼 추가 */}
                                    <div
                                        onClick={navigateToOrderHistory}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "12px 0 0 0",
                                            borderTop: "1px solid #f0f0f0",

                                            cursor: "pointer"
                                        }}
                                    >
                                        <P color={"#666"} size={14} weight={500}>주문 내역 더보기</P>
                                        <img src={rightIcon} style={{ width: "7px", marginLeft: "6px", opacity: 0.7 }} />
                                    </div>
                                </>
                            ) : (
                                <FlexChild width={"100%"}>
                                    <div style={{ height: "70px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <P color={"#666"}>최근 주문 내역이 없습니다</P>
                                    </div>
                                    <Dummy height={"12px"} />

                                    <div
                                        onClick={navigateToOrderHistory}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "12px 0 0 0",
                                            borderTop: "1px solid #f0f0f0",

                                            cursor: "pointer"
                                        }}
                                    >
                                        <P color={"#666"} size={14} weight={500}>주문 내역 더보기</P>
                                        <img src={rightIcon} style={{ width: "7px", marginLeft: "6px", opacity: 0.7 }} />
                                    </div>
                                </FlexChild>
                            )}
                        </VerticalFlex>
                    </div>
                </FlexChild>
            </VerticalFlex>
            {showModal && (
                <SimpleStoreDetailModal
                    store={selectedStore}
                    isMapView={true}
                    onClose={() => setShowModal(false)}
                />
            )}
        </Container>
    );
}

export default Main2;
